import React from 'react';
import { CursosPageQuery_horarios } from '../../graphql/queries/__generated__/CursosPageQuery';
import { Form, FormField } from '../../../shared/components/form_components/form';
import { FormGroup } from '../../../shared/components/form_components/group';
import { InputForm } from '../../../shared/components/form_components/input';
import { Container } from './styles';
import { InputSelect } from '../../../shared/components/form_components/select';
import { InputToggle } from '../../../shared/components/form_components/toggle';

interface Props {
  turma?: Partial<FormTurma>;
  horarios?: CursosPageQuery_horarios[];
  onSubmit: (turma: FormTurma) => void;
  onCancel?: () => void;
}

interface FormTurma {
  id_turma?: number;
  id_oferta: number;
  id_horario: number;
  num_turma: number;
  dias_semana: number;
  ativa: boolean;
}

const FormularioTurma: React.FC<Props> = (props) => {
  const fields: FormField[] = [
    {
      name: 'id_turma',
      label: 'Id da turma',
      type: 'number',
      value: props.turma?.id_turma,
      required: true,
      disabled: true,
      component: InputForm,
    },
    {
      name: 'id_oferta',
      label: 'Id oferta',
      type: 'number',
      value: props.turma?.id_oferta,
      required: true,
      disabled: true,
      component: InputForm,
    },
    {
      name: 'group_num_turma_dias_semana',
      type: 'group',
      sub_fields: [
        {
          name: 'id_horario',
          label: 'Id horário',
          placeholder: 'Selecione um horário',
          type: 'number',
          defaultValue: props.turma?.id_horario,
          items: props.horarios?.map((h) => ({
            label: h.hora_inicio + ' - ' + h.hora_fim,
            value: h.id_horario,
          })),
          required: true,
          readOnly: true,
          component: InputSelect,
        },
        {
          name: 'num_turma',
          label: 'N° da turma',
          type: 'number',
          defaultValue: props.turma?.num_turma,
          required: true,
          component: InputForm,
        },
      ],
      component: FormGroup,
    },
    {
      name: 'group_dias_semana',
      type: 'group',
      sub_fields: [
        {
          name: 'dias_semana',
          label: 'Dias da semana',
          type: 'number',
          defaultValue: props.turma?.dias_semana,
          required: true,
          component: InputForm,
        },
        {
          name: 'ativa',
          label: 'Ativa',
          id: 'turma_ativa',
          type: 'checkbox',
          defaultChecked: props.turma?.ativa,
          required: true,
          component: InputToggle,
        },
      ],
      component: FormGroup,
    },
  ];

  return (
    <Container>
      <Form
        fields={fields}
        form_name='turma'
        is_edit={Boolean(props.turma?.id_turma)}
        onSubmit={props.onSubmit}
        onCancel={props.onCancel}
      />
    </Container>
  );
};

export { FormularioTurma };
export type { FormTurma };
